package org.teddapp.project.sync

import com.tedd.db.TeddDatabase

/**
 * Les fichiers joints dans le moteur de synchronisation : la ligne qui décrit le
 * fichier voyage comme les autres, les octets passent à part (voir FileTransfer).
 */
internal object FileSyncOps {

    fun dirtyQuery(entity: EntityKind, db: TeddDatabase): app.cash.sqldelight.Query<*> = db.attachmentQueries.selectDirty()

    fun selectDirty(entity: EntityKind, db: TeddDatabase): List<RemoteRow> =
        db.attachmentQueries.selectDirty().executeAsList().map { row(it) }

    fun selectAll(entity: EntityKind, db: TeddDatabase): List<RemoteRow> =
        db.attachmentQueries.selectAll().executeAsList().map { row(it) }

    fun markSynced(entity: EntityKind, db: TeddDatabase, id: String, updatedAt: Long, syncedAt: Long) {
        db.attachmentQueries.markSynced(syncedAt, id, updatedAt)
    }

    fun selectByIdAnyState(entity: EntityKind, db: TeddDatabase, id: String): LocalSnapshot? =
        db.attachmentQueries.selectByIdAnyState(id).executeAsOneOrNull()?.let { LocalSnapshot(it.updated_at, it.is_deleted == 1L) }

    fun insertFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        val p = row.payload
        db.attachmentQueries.insert(
            row.id,
            p.str("owner_kind") ?: "note",
            p.str("owner_id") ?: "",
            p.str("file_name") ?: "",
            p.str("mime_type") ?: "application/octet-stream",
            p.long("size_bytes") ?: 0L,
            p.str("storage_key"),
            p.str("sha256"),
            p.long("width"),
            p.long("height"),
            p.str("status") ?: "pending",
            p.long("order_index") ?: 0L,
            p.long("created_at") ?: row.updatedAt,
            row.updatedAt,
        )
    }

    fun updateFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        val p = row.payload
        db.attachmentQueries.update(
            p.str("owner_kind") ?: "note",
            p.str("owner_id") ?: "",
            p.str("file_name") ?: "",
            p.str("mime_type") ?: "application/octet-stream",
            p.long("size_bytes") ?: 0L,
            p.str("storage_key"),
            p.str("sha256"),
            p.long("width"),
            p.long("height"),
            p.str("status") ?: "pending",
            p.long("order_index") ?: 0L,
            row.updatedAt,
            row.id,
        )
    }

    fun softDeleteFromRemote(entity: EntityKind, db: TeddDatabase, row: RemoteRow, deletedAt: Long) {
        db.attachmentQueries.softDelete(deletedAt, row.updatedAt, row.id)
    }

    fun restoreIfDeleted(entity: EntityKind, db: TeddDatabase, row: RemoteRow) {
        db.attachmentQueries.restore(row.updatedAt, row.id)
    }

    private fun row(it: com.tedd.db.Attachment) = RemoteRow(it.id, it.updated_at, it.is_deleted == 1L, it.deleted_at, mapOf(
        "owner_kind" to it.owner_kind,
        "owner_id" to it.owner_id,
        "file_name" to it.file_name,
        "mime_type" to it.mime_type,
        "size_bytes" to it.size_bytes,
        "storage_key" to it.storage_key,
        "sha256" to it.sha256,
        "width" to it.width,
        "height" to it.height,
        "status" to it.status,
        "order_index" to it.order_index,
        "created_at" to it.created_at,
    ))
}
